import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { SettingsHeader, PrivacyPolicyBody } from '@cubemeet/ui';
import { useSettingsTranslation } from '../modules/settings/i18n';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const { t: settingsT } = useSettingsTranslation();

  return (
    <View style={styles.container}>
      <SettingsHeader 
        title={settingsT('privacyScreen.privacyPolicy')} 
        onBack={() => navigate(-1)}
      />
      <View style={styles.content}>
        <PrivacyPolicyBody t={settingsT} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F8F9FA',
    height: '100%',
  },
  content: {
    flex: 1,
    maxWidth: 600,
    width: '100%',
    alignSelf: 'center',
    backgroundColor: '#ffffff',
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    marginBottom: 20,
    padding: 20,
    ...Platform.select({
      default: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 3,
      },
      web: {
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }
    }),
  },
});

export default PrivacyPolicyPage;
